import { Subscription } from 'rxjs';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpTicketService } from '../../../service/http-ticket.service';
import {
	TicketDto,
	WorkflowDto,
	WorkflowStepDto,
	AgentDto,
	TicketBundleDto,
	TicketModeEnum,
} from '../../../service/dto';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { TicketFormComponent } from '../tickets-form/ticket-form.component';
import { Location } from '@angular/common';
import { AuthService } from '../../../service/auth.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TicketAssignModalComponent } from '../tickets-assign-modal/ticket-assign-modal.component';
import { environment } from '../../../../environments/environment';

@Component({
	selector: 'app-ticket-list',
	standalone: false,
	templateUrl: './ticket-list.component.html',
	styleUrl: './ticket-list.component.scss',
})
export class TicketListComponent implements OnInit, OnDestroy {
	ticketMode!: TicketModeEnum;
	bundle?: TicketBundleDto;
	agents?: AgentDto[];
	_selectedAgent: AgentDto | null = null;

	workflows?: WorkflowDto[];
	workflow?: WorkflowDto;

	stepId?: number;
	step?: WorkflowStepDto;

	searchText?: string;
	subscription = new Subscription();

	tickets: TicketDto[] = [];
	total = 0;
	pageSize = 10;
	pageIndex = 1;
	loading = false;
	currentStepIndex = 0;

	isShowMembershipColumn=true;
	isShowTicketReferenceColumn=true;

	constructor(
		private authService: AuthService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private ticketService: HttpTicketService,
		private location: Location,
		private modal: NzModalService) { }

	ngOnInit(): void {
		this.isShowMembershipColumn=environment.ticketListShowMembershipColumn;
		this.isShowTicketReferenceColumn=environment.ticketListShowTicketReferenceColumn;

		this.subscription.add(this.activatedRoute.params.subscribe(params => {
			this.ticketMode = params['ticketMode']!;
			const workflowId = +params['workflowId'];
			this.stepId = params['stepId'];
			const agentId = this.activatedRoute.snapshot.queryParams['agentId'];
			console.log("navigation changed", workflowId, this.stepId, agentId);

			if (workflowId) {
				this.ticketService.getTicketBundle(this.ticketMode, !agentId ? null : agentId, workflowId, 0, 0).subscribe(result => {
					this.workflows = result.workflows;
					this.agents = result.agents;
					this.bundle = result;
					if (agentId) {
						var selectedAgent = this.agents.find(item => item.id = agentId);
						this.selectedAgent = !selectedAgent ? null : selectedAgent;
					}
					if (workflowId) {
						this.selectWorkflow(this.workflows.filter(item => item.id == workflowId)[0]);
					}
				});
			} else {
				this.ticketService.getWorkflows(this.ticketMode).subscribe(result => {
					this.workflows = result;
					this.agents = [];
					this.selectedAgent = this.authService.authState!.agent;
					this.workflow = undefined;
					this.step = undefined;
					this.stepId = undefined;
					this.tickets = [];
					this.bundle = undefined;
				});
			}
		}));
	}
	selectWorkflow(input: WorkflowDto) {
		if (!this.bundle) {
			if (this.activatedRoute.snapshot.queryParams['agentId']) {
				this.router.navigate(['/ticket', this.ticketMode, input.id, 'list'], { queryParams: { agentId: this.activatedRoute.snapshot.queryParams['agentId'] } });
			} else {
				this.router.navigate(['/ticket', this.ticketMode, input.id, 'list']);
			}
			return;
		}
		this.pageIndex = 1;
		this.workflow = input;
		if (this.stepId) {
			this.selectWorkflowStep(input.steps.filter(item => item.id == this.stepId)[0]);
		} else {
			this.selectWorkflowStep(input.steps[0]);
		}
	}
	selectWorkflowStep(input: WorkflowStepDto) {
		if (!input) {
			input = this.workflow!.steps[0];
		}
		this.stepId = input.id;
		this.pageIndex = 1;
		this.step = input;
		this.currentStepIndex = this.workflow!.steps.findIndex(item => item.id == this.step!.id);

		if (this.selectedAgent) {
			console.log("Updating URL 1 ", this.selectedAgent);
			this.location.go(`ticket/${this.ticketMode}/${this.workflow!.id}/${this.step!.id}/list?agentId=${this.selectedAgent.id!}`);
		} else {
			console.log("Updating URL 2 ", this.selectedAgent);
			this.location.go(`ticket/${this.ticketMode}/${this.workflow!.id}/${this.step!.id}/list`);
		}

		this.ticketService.queryTickets(this.workflow!, this.selectedAgent?.id ?? null, this.step, this.pageIndex, this.pageSize)
			.subscribe({
				next: (res) => {
					this.loading = false;
					this.tickets = res.list;
					this.total = res.totalItems;
					this.pageIndex = res.pageIndex;
					this.pageSize = res.pageSize;
				},
				error: () => {
					this.loading = false;
				},
			});
	}
	get selectedAgent(): AgentDto | null {
		return this._selectedAgent;
	}
	set selectedAgent(input: AgentDto | null) {
		console.log("Setting agent", this._selectedAgent, input);
		this._selectedAgent = input;
	}


	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	openTicket(input: TicketDto) {
		this.router.navigate(['/ticket', this.ticketMode, input.id]);
	}

	getThis(): TicketListComponent {
		return this;
	}

	onQueryParamsChange(params: NzTableQueryParams, that: TicketListComponent): void {
		const { pageIndex, pageSize } = params;
		if (pageIndex == that.pageIndex && pageSize == that.pageSize) {
			return;
		}
		that.pageIndex = pageIndex;
		that.pageSize = pageSize;

		this.ticketService.queryTickets(this.workflow!, this.selectedAgent?.id ?? null, this.step, this.pageIndex, this.pageSize)
			.subscribe({
				next: (res) => {
					this.loading = false;
					this.tickets = res.list;
					this.total = res.totalItems;
					this.pageIndex = res.pageIndex;
					this.pageSize = res.pageSize;
				},
				error: () => {
					this.loading = false;
				},
			});
	}

	// search() {
	// 	this.loading = true;
	// 	this.ticketService.searchTickets(this.searchText!, this.pageIndex, this.pageSize).subscribe({
	// 		next: (res) => {
	// 			this.loading = false;
	// 			this.tickets = res.list;
	// 			this.total = res.totalItems;
	// 			this.pageIndex = res.pageIndex;
	// 			this.pageSize = res.pageSize;
	// 		},
	// 		error: () => {
	// 			this.loading = false;
	// 		},
	// 	});
	// }
	getSlaClass(ticket: TicketDto): 'success' | 'info' | 'warning' | 'error' {
		if (ticket.slaLevel == 'Good') {
			return 'success';
		}
		if (ticket.slaLevel == 'Warning') {
			return 'warning';
		}
		return 'error';
	}
	onStepIndexChange(nextIdx: number): void {
		this.selectWorkflowStep(this.workflow!.steps[nextIdx]);
	}
	getAuthedAgent(): AgentDto {
		return this.authService.authState!.agent;
	}
	onSelect(value: AgentDto | null) {
		this.selectedAgent = value;
		this.ticketService.getTicketBundle(this.ticketMode, this.selectedAgent?.id ?? null, this.workflow!.id, 0, 0).subscribe(result => {
			this.workflows = result.workflows;
			this.agents = result.agents;
			if (value) {
				this.selectedAgent = this.agents.find(item => item.id == value.id) ?? null;
			}
			this.selectWorkflow(this.workflows.filter(item => item.id == this.workflow!.id)[0]);
		});
	}
	filterOption = (input: string, option: any): boolean => option.nzLabel.toLowerCase().includes(input.toLowerCase());

	assignTicketToThisAgent(ticket: TicketDto) {
		this.ticketService.assignTicketToAgent(ticket, this.authService.authState!.agent).subscribe(result => {
			this.tickets[this.tickets.findIndex(c => c.id === ticket.id)] = result;
		});
	}
	showAssignTicketToAgentPopup(ticket: TicketDto) {
		const modalRef = this.modal.create({
			nzContent: TicketAssignModalComponent,
			nzFooter: null
		});
		modalRef.componentInstance!.agents = this.agents!;
		modalRef.componentInstance!.ticket = ticket;
	}

}
